import '../styles/banner.scss'
import { Icon } from '@vista-digital/occ-ui'
import type { FC } from 'react'
import { Link } from 'react-router-dom-v7'
import { cmsDataService } from '@/common/services/cms.data.service'

export const Banner: FC = () => {
    const bannerLink = cmsDataService.get().footer.featureLinks.bannerLink

    if (!bannerLink) {
        return null
    }

    return (
        <div className="footer-banner">
            <Link to={bannerLink.url} target={bannerLink.target}>
                {bannerLink.name} <Icon name="arrow-right" />
            </Link>
        </div>
    )
}
